import React from "react";
import _ from "lodash";
import {
  captureDebugStack,
  setDebugStackForNextSubscription,
} from "../../lib/reflux/monitoring-hooks";

/**
 * In the state object each key represents the property name that they data will be at on the Component.
 *
 * Example Usage:
 *
 * connectToStores(Component,
 * [
 *    {
 *        store:Store1,
 *        state: {
 *            user:Store1.getState
 *        }
 *    },
 *    {
 *        store:Store2,
 *        state: {
 *            data:Store2.getState,
 *            moreData:Store2.getSpecialValue
 *        }
 *    }
 * ])
 *
 * @param Component
 * @param config
 */

function connectToStores(Component, /** Array **/ config) {
  // Capture stack NOW - the file using connectToStores IS on the stack
  const capturedStack = captureDebugStack();

  return class extends React.Component {
    constructor(props) {
      super(props);

      this.unsubscribeFuncs = [];

      let stateProps = {};

      for (let i = 0, l = config.length; i < l; i++) {
        _.forEach(config[i].state, function (statePropFunc, statePropKey) {
          stateProps[statePropKey] = statePropFunc
            ? statePropFunc()
            : config[i].store.getInitialState();
        });
      }

      this.state = stateProps;
    }

    componentDidMount() {
      for (let i = 0, l = config.length; i < l; i++) {
        // Set the captured stack before each subscription
        setDebugStackForNextSubscription(capturedStack);
        this.unsubscribeFuncs.push(
          config[i].store.listen(this._onStoreChange.bind(this, config[i].state))
        );
      }
    }

    componentWillUnmount() {
      for (let i = 0, l = this.unsubscribeFuncs.length; i < l; i++) {
        _.attempt(this.unsubscribeFuncs[i]);
      }

      this.unsubscribeFuncs = null;
    }

    _onStoreChange(/** Object **/ storeStateMap, /** Object **/ storeData) {
      let stateChange = {};

      _.forEach(storeStateMap, function (statePropFunc, statePropKey) {
        stateChange[statePropKey] = statePropFunc ? statePropFunc() : storeData;
      });

      this.setState(stateChange);
    }

    render() {
      return <Component {...this.state} {...this.props} />;
    }
  };
}

export default connectToStores;
